import { Fleet } from "Models/fleet";

import { EquipmentType } from "./enums";

export const getEquipmentName = (
  equipment: Pick<Fleet, "equipmentType" | "description" | "fleetNumber">,
  generalValue?: string,
  fleetValue?: string
) => {
  const { equipmentType, description, fleetNumber } = equipment;
  const isTypeGeneral = [EquipmentType.GENERAL].includes(equipmentType as EquipmentType);

  if (isTypeGeneral) {
    const properties = {
      title: generalValue || equipmentType,
      text: `${description ? ` - ${description}` : ""}`,
    };

    return {
      ...properties,
      fullText: `${properties.title}${properties.text}`,
    };
  }

  const properties = {
    title: fleetValue || equipmentType,
    text: fleetNumber ? ` #${fleetNumber}` : "",
  };

  return {
    ...properties,
    fullText: `${properties.title}${properties.text}`,
  };
};
